export const SET_STRUCTURE_LIST = 'SET_STRUCTURE_LIST';
export const SET_STRUCTURE_LIST_CODE = 'SET_STRUCTURE_LIST_CODE';
export const SET_LOTS = 'SET_LOTS';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_LOADING_ON = 'SET_LOADING_ON';
export const SET_LOADING_OFF = 'SET_LOADING_OFF';
export const CLEAR_STRUCTURE_CONFIGURATION = 'CLEAR_STRUCTURE_CONFIGURATION';
